/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type PermissionScope =
  (typeof PermissionScope)[keyof typeof PermissionScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionScope = {
  UNLIMITED: "UNLIMITED",
  GLOBAL: "GLOBAL",
  PROJECT: "PROJECT",
  PERSONAL: "PERSONAL",
  QS: "QS",
  PORTFOLIO: "PORTFOLIO",
  OWN: "OWN",
  ASSIGNED: "ASSIGNED",
  LIMITED: "LIMITED",
  PLANNED: "PLANNED",
} as const;
